module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0090.jpg?v=8f879db6";